import React from "react";
import LegalMarkdownPage from "./LegalMarkdownPage";

import privacyEnglish from "../docs/legal/privacy-policy/privacy.en.md"; //
import privacyFrench from "../docs/legal/privacy-policy/privacy.fr.md";
import privacyArabic from "../docs/legal/privacy-policy/privacy.ar.md";
import privacySpanish from "../docs/legal/privacy-policy/privacy.en.md";
import privacyItalian from "../docs/legal/privacy-policy/privacy.en.md";

import "../styles/LegalPages.css";

const privacyDocuments = {
  en: privacyEnglish,
  fr: privacyFrench,
  ar: privacyArabic,
  es: privacySpanish,
  it: privacyItalian,
};

const PrivacyPolicy = () => {
  return (
    <LegalMarkdownPage
      documents={privacyDocuments}
      containerClassName="legal-page-container"
      headingClassName="legal-page-heading"
      errorMessage="The Privacy Policy could not be loaded."
    />
  );
};

export default PrivacyPolicy;
